import { Injectable } from "@angular/core";
import { environment } from '../../../../../environments/environment';
import { BaseService } from '../../../base/util/base.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router } from "@angular/router";
import { FiltroBuscaGto } from '../../../base/vo/filtro-busca-gto';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { URL_SITUACOES, URL_COUNT_PENDENTES, URL_PRESTADOR_EXECUTANTE } from '../../../base/util/url-util';
import { NovaGtoService } from "../../../nova-gto/nova-gto.service";
import { Message } from 'primeng/components/common/api';
import { MessageService } from 'primeng/components/common/messageservice';

@Injectable()
export class BuscarGtoService extends BaseService{

    constructor(public http: HttpClient, public novaGtoService: NovaGtoService, public messageService: MessageService){
            super(http, messageService);
        }

        buscarGto(paginado?: boolean, filtroBuscaGto?: FiltroBuscaGto){
        	localStorage.setItem('filtro-busca-gto', JSON.stringify(filtroBuscaGto));
            let url = this.montarUrl("gto?", paginado, filtroBuscaGto.nPagina, 5, filtroBuscaGto);
            return this.get(url);
        }
        
        buscarGtoPorNumero(numero: string){
        	let filtroBuscaGto: FiltroBuscaGto = new FiltroBuscaGto();
        	filtroBuscaGto.numero = numero;
            let url = this.montarUrl("gto?", false, 0, 1, filtroBuscaGto);
            return this.get(url);
        }

        situacaoGTODropdown(){
            return this.get(URL_SITUACOES);
        }

        prestadorExecutanteList(){
            return this.get(URL_PRESTADOR_EXECUTANTE);
        }

        downloadExcel(filtroBuscaGto?: FiltroBuscaGto) {
            let url = this.montarUrl("gto/exportar?", null, 0, null, filtroBuscaGto);

            return this.http
                .get(url, {
                    headers: new HttpHeaders().set('Content-Type', 'application/json'),
                    responseType: 'text' 
                    })
                .map((response: any) => {
                    return response;
                });
        }

        countPendentes(){
            return this.get(URL_COUNT_PENDENTES);
        }

        //TODO -- adicionar prestador na busca: prestadorExecutante.codigo
        montarUrl(funcName, paginado?: boolean, nPagina?: number, nQtdPorPagina?, filtroBuscaGto?: FiltroBuscaGto){
            let url = environment.urlApi+funcName;
                url += "nPagina=" + nPagina;

            if(nQtdPorPagina !== undefined && nQtdPorPagina !== null){
                url += "&nQtdPorPagina=" + nQtdPorPagina;
            }
            if(filtroBuscaGto.codigoBeneficiario !== undefined && filtroBuscaGto.codigoBeneficiario !== null && filtroBuscaGto.codigoBeneficiario !== ''){
                url += "&codigoBeneficiario=" + filtroBuscaGto.codigoBeneficiario;
            }
            if(filtroBuscaGto.numero !== undefined && filtroBuscaGto.numero !== null && filtroBuscaGto.numero !== ''){
                url += "&numero=" + filtroBuscaGto.numero;
            }
            if(filtroBuscaGto.nomeBeneficiario !== undefined && filtroBuscaGto.nomeBeneficiario !== null && filtroBuscaGto.nomeBeneficiario !== ''){
                url += "&nomeBeneficiario=" + filtroBuscaGto.nomeBeneficiario;
            }
            if(filtroBuscaGto.status !== undefined && filtroBuscaGto.status !== null){
                if(filtroBuscaGto.status.codigo !== undefined){
                    url += "&situacao=" + filtroBuscaGto.status.codigo;
                }
                
            }
            if(filtroBuscaGto.dataInicial !== undefined && filtroBuscaGto.dataInicial !== null){
                url += "&dataInicial=" + filtroBuscaGto.dataInicial;
            }
            if(filtroBuscaGto.dataFinal !== undefined && filtroBuscaGto.dataFinal !== null){
                url += "&dataFinal=" + filtroBuscaGto.dataFinal;
            }
            if(paginado !== undefined && paginado !== null){
                url += "&paginado=" + paginado;
            }
            if(filtroBuscaGto.prestadorExecutante !== undefined && filtroBuscaGto.prestadorExecutante !== null){
                if(filtroBuscaGto.prestadorExecutante.codigo !== undefined){
                    url += "&codigoPrestador=" + filtroBuscaGto.prestadorExecutante.codigo;
                }
            }
            if(filtroBuscaGto.possuiObservacao){
                url += "&possuiObservacao=true";
            }
            return url;
        }
}


// WEBPACK FOOTER //
// ./src/app/components/dashboard/gto-dashboard/buscar-gto/buscar-gto.service.ts